import { AbsBaseRequester } from '@datachain/ui-sdk/common';

export interface IPathVariable {
	[key: string]: number | string | boolean | undefined | null;
}

export interface IQueryParams {
	[key: string]:
		| number
		| string
		| boolean
		| Array<number | string | boolean>
		| null
		| undefined;
}
export abstract class DcBaseRequester<
	M,
	V = IPathVariable,
	Q = IQueryParams,
> extends AbsBaseRequester<M, V, Q> {
	protected abstract override resource: string;
	protected abstract override elementsListUrl: string;
	protected abstract override singleElementUrl: string;
	protected constructor() {
		super();
	}

	protected assignBasePath(): string {
		this.basePathEntity.setBasePath('');
		return this.basePathEntity.getBasePath();
	}

	protected assignFunctionalDocUrl(): string {
		this.baseDocumentationEntity.setFuncBasePath('/doc/dc_funct');
		return this.baseDocumentationEntity.getFuncBasePath();
	}

	protected assignTechnicalDocUrl(): string {
		this.baseDocumentationEntity.setTechBasePath('/doc/dc_tech');
		return this.baseDocumentationEntity.getTechBasePath();
	}

	protected getResourceUrl(key: string): string {
		return this.generateResourceUrl(key).replaceAll('//', '/');
	}
}
